/**
 * CalculateApplicationPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, Information, ModalLayout } from 'components';
import {
  Button,
  Select,
  Table,
  Spin,
  Descriptions,
  Divider,
  Switch,
  Input,
  Dropdown,
  Space,
  Flex,
} from 'antd';
import {
  LeftOutlined,
  RightOutlined,
  SearchOutlined,
  HistoryOutlined,
  UnorderedListOutlined,
  DownOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';
import { SETTLEMENT_STATUS } from 'constants/SettlementConstants';
import ShopInformationList from 'routes/admin.routes/admin.orders/OrderList/components/ShopInformationList';
import { downloadXlsx } from 'utils/XlsxDownloader';
import { on } from 'events';
/**----------------------------------------
 * [Component] 정산내역 - 프레젠터
 * ----------------------------------------
 */
const CalculateApplicationPresenter = ({
  permission,
  currentDate,
  loading,
  settlementList,
  currentShop,
  setCurrentShop,
  onChangeMonth,
  onChangeAmountStatus,
  // onChangeStatusAll,
  onUpdateWithdraw,
  onDeleteWithdraw,
  // 정산목록 선택항목
  selectedList,
  setSelectedList,
  // 출금목록
  withdrawList,
  withdrawListModal,
  setWithdrawListModal,
  modalType,
  setModalType,
  // 업체정보
  shopInformation,
  // 출금처리버튼
  withdrawApplicationModal,
  setWithdrawApplicationModal,

  withdrawData,
  onChangeWithdrawData,
  onWithdrawComplete,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */

  const totalCount = settlementList.length ?? 0;
  const totalProductCount = settlementList.reduce(
    (acc, cur) => acc + cur.sale_num,
    0
  );
  const totalPrice = settlementList.reduce(
    (acc, cur) => acc + cur.sale_price,
    0
  );
  const comission = settlementList.reduce(
    (acc, cur) => acc + cur.sale_price - cur.settlement_amount_price,
    0
  );
  const totalCalculatePrice = settlementList
    .filter((item) => item.settlement_amount_status !== 'DECIDED')
    .reduce((acc, cur) => acc + cur.settlement_amount_price, 0);

  // 출금완료내역
  const totalCalculateWithdraw = !withdrawList
    ? 0
    : withdrawList.reduce((acc, cur) => acc + cur.withdraw_price, 0);
  // VIEW
  return (
    <>
      <Content
        maxWidth={'100%'}
        height={'100%'}
        padding={20}
        backgroundColor={'none'}
      >
        <Title size={3} style={{ marginBottom: 10 }}>
          출금신청 내역
        </Title>

        {/* ==== Loading - start ==== */}
        <Spin spinning={loading}>
          <Row gutter={[1, 1]}>
            {/* === 업체목록 - start === */}
            {permission === 'ADMIN' && (
              <Col x={4}>
                <Content
                  maxWidth={'100%'}
                  height={'100%'}
                  minHeight={540}
                  padding={0}
                  backgroundColor={'#fff'}
                  className="boxShadow"
                >
                  <ShopInformationList onChange={setCurrentShop} />
                </Content>
              </Col>
            )}
            {/* === 업체목록 - end === */}

            {/* === 정산내역 - start === */}
            <Col x={permission === 'ADMIN' ? 20 : 24}>
              <Content
                maxWidth={'100%'}
                height={'100%'}
                minHeight={540}
                padding={0}
                backgroundColor={'#fff'}
                className="boxShadow"
              >
                {/* === Line 1 === */}
                <Content
                  maxWidth={'100%'}
                  style={{
                    height: 53,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <h2
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: '#404040',
                      lineHeight: '133%',
                      width: '33.33%',
                    }}
                  >
                    {permission === 'ADMIN' && '출금 및 출금대기 내역'}
                  </h2>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 25,
                      fontWeight: 700,
                      width: '33.33%',
                    }}
                  >
                    <Button
                      shape="circle"
                      onClick={() => onChangeMonth('left')}
                      disabled={currentShop === null}
                    >
                      <LeftOutlined />
                    </Button>
                    <span
                      style={{
                        padding: '0px 10px',
                        width: 165,
                        textAlign: 'center',
                      }}
                    >
                      {currentDate.year}년 {currentDate.month}월
                    </span>
                    <Button
                      shape="circle"
                      onClick={() => onChangeMonth('right')}
                      disabled={currentShop === null}
                    >
                      <RightOutlined />
                    </Button>
                  </div>

                  <div style={{ width: '33.33%', textAlign: 'right' }}>
                    <Button
                      style={{ marginRight: 4 }}
                      disabled={currentShop === null}
                      onClick={() =>
                        downloadXlsx({
                          columns: [
                            {
                              title: '정산코드',
                              dataIndex: 'settlement_amount_id',
                            },
                            {
                              title: '업체명',
                              dataIndex: 'company_name',
                            },
                            {
                              title: '주문금액',

                              dataIndex: 'sale_price',
                            },
                            {
                              title: '상품수',

                              dataIndex: 'sale_num',
                            },
                            {
                              title: '정산금액',

                              dataIndex: 'settlement_amount_price',
                            },
                            {
                              title: '정산상태',

                              dataIndex: 'settlement_amount_status',
                            },
                            {
                              title: '생성일',

                              dataIndex: 'created_at',
                            },
                          ],
                          rows: settlementList?.map((_item) => {
                            return {
                              ..._item,
                              settlement_amount_status:
                                SETTLEMENT_STATUS[
                                  _item?.settlement_amount_status
                                ]?.title,
                            };
                          }),
                          fileName: '출금내역',
                        })
                      }
                    >
                      엑셀로 다운로드
                    </Button>{' '}
                    <Button
                      type="primary"
                      style={{ marginRight: 4 }}
                      onClick={() => {
                        setWithdrawApplicationModal(true);
                        setModalType('WITHDRAW_APPLICATION');
                      }}
                      // disabled={currentShop === null}
                      disabled={
                        !selectedList ||
                        selectedList.length < 1 ||
                        currentShop === null
                          ? true
                          : false
                      }
                    >
                      {permission === 'ADMIN' ? '일괄출금완료' : '일괄출금신청'}
                    </Button>
                    <Dropdown
                      disabled={
                        !selectedList ||
                        selectedList.length < 1 ||
                        currentShop === null
                          ? true
                          : false
                      }
                      menu={{
                        items: [
                          {
                            key: 2,
                            label: '확정',
                            onClick: () => onChangeAmountStatus('DECIDED'),
                          },
                          {
                            key: 3,
                            label: '미확정',
                            onClick: () => onChangeAmountStatus('UNDECIDED'),
                          },
                        ],
                      }}
                    >
                      <Button
                        disabled={
                          !selectedList ||
                          selectedList.length < 1 ||
                          currentShop === null
                            ? true
                            : false
                        }
                      >
                        <Space>
                          정산상태변경
                          <DownOutlined />
                        </Space>
                      </Button>
                    </Dropdown>
                    {/* <Button
                      type="primary"
                      style={{ marginRight: 4 }}
                      onClick={() => onChangeAmountStatus()}
                      // disabled={currentShop === null}
                    >
                      일괄상태변경
                    </Button> */}
                    {/* <Button style={{ marginRight: 4 }}>정산메일발송</Button>
                    <Button type="primary" style={{ width: 165 }}>
                      정산하기
                    </Button> */}
                  </div>
                </Content>

                {/* === 업체정보 === */}
                <Content maxWidth={'100%'} padding={10} className="boxShadow">
                  {/* {(() => {
                    console.log('shopInformation: ', shopInformation);
                  })()} */}
                  <Descriptions
                    bordered
                    items={[
                      {
                        key: '1',
                        label: '업체명',
                        children: shopInformation?.shop_information_name ?? '-',
                      },
                      {
                        key: '2',
                        label: '사업자번호',
                        children:
                          shopInformation?.mall_information?.business_num ??
                          '-',
                      },
                      {
                        key: '3',
                        label: '대표자',
                        children:
                          shopInformation?.shop_information_address ?? '-',
                      },
                      {
                        key: '4',
                        label: '주소',
                        children:
                          shopInformation?.shop_information_address ?? '-',
                      },
                      {
                        key: '5',
                        label: '계좌정보',
                        children: (
                          <>{`${
                            shopInformation?.mall_information?.bank_name ?? ''
                          } - ${
                            shopInformation?.mall_information?.account_number ??
                            ''
                          }`}</>
                        ),
                      },
                    ]}
                  />
                </Content>
                {/* === 업체정보 === */}

                {/* === Line 2 === */}
                <Content maxWidth={'100%'} padding={10} className="boxShadow">
                  <Information
                    content={[
                      '오늘 입금될 상품 결제대금과 과거 정산내역, 상품주문별 상세 정산내역을 확인하실 수 있습니다.',
                      '상품주문별 결제대금 및 수수료와 관련된 결제대금 정산, 할인/적립과 관련된 혜택정산, 상품 판매대금에 연계되지 못하고 적용되는 일별/공제 환급, 지급보류 금액을 확인하실 수 있습니다.',
                      '판매 내역은 부가세신고를 돕기 위한 참고 자료를 확인하실 수 있습니다.'
                    ]}
                  />
                </Content>

                {/* === Line 3 === */}
                {/* === Statics === */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  {[
                    {
                      label: '합계금액',
                      value: 0,
                      width: '20%',
                      value: totalPrice,
                    },
                    {
                      label: '정산항목',
                      value: 0,
                      width: '19%',
                      value: totalCount,
                      unit: '건',
                    },
                    {
                      label: '수수료',
                      width: '19%',
                      value: comission,
                    },

                    {
                      label: '출금예정금액',
                      width: '21%',
                      value: totalCalculatePrice,
                    },

                    {
                      label: '출금완료',
                      width: '23%',
                      value: totalCalculateWithdraw,
                      subButton: (
                        <Button
                          shape="round"
                          size="small"
                          style={{ marginLeft: 5, top: -3 }}
                          onClick={() => setWithdrawListModal(true)}
                        >
                          내역
                        </Button>
                      ),
                      onClick: () => setWithdrawListModal(true),
                    },
                  ].map((_item, _index) => (
                    <div
                      style={{
                        borderRight: '1px solid #EBEBEB',
                        // width: '20%',
                        width: _item.width,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      className={_item.onClick ? 'cursorOverOpacity' : ''}
                      onClick={_item.onClick ?? null}
                    >
                      <h4
                        style={{
                          fontSize: 18,
                          fontWeight: 700,
                          color: '#4B4B4B',
                          paddingRight: 30,
                        }}
                      >
                        {_item.label}
                      </h4>
                      <p
                        style={{
                          fontSize: 24,
                          fontWeight: 400,
                          color: 'var(--black-color)',
                        }}
                      >
                        {stringToMoneyFormat(
                          _item.value,
                          `${_item.unit ?? '원'}`
                        )}
                        {_item.subButton ? _item.subButton : null}
                      </p>
                    </div>
                  ))}
                </div>
                {/* === Line 3 === */}
                {/* === Line 4 === */}
                <Content maxWidth={'100%'} padding={14}>
                  <Table
                    size="small"
                    bordered
                    dataSource={settlementList.map((item) => ({
                      key: item.settlement_amount_id,
                      ...item,
                    }))}
                    // pagination={{ pageSize: 100 }}
                    pagination={false} // 페이지네이션 비활성화
                    scroll={{ y: 680, x: 1200 }} // 테이블 자체 스크롤 설정
                    rowSelection={{
                      type: 'checkbox',
                      selectedRowKeys: selectedList
                        ? selectedList.map((item) => item.settlement_amount_id)
                        : [],
                      onChange: (_selectedRowKeys, _selectedRows) => {
                        setSelectedList(_selectedRows);
                      },
                      // getCheckboxProps: (record) => ({
                      //   disabled: record.disabled, // 특정 행의 'disabled' 값에 따라 체크박스 비활성화
                      // }),
                    }}
                    columns={[
                      {
                        title: '정산코드',
                        key: 'settlement_amount_id',
                        dataIndex: 'settlement_amount_id',
                        width: 120,
                        align: 'center',
                        sorter: (a, b) =>
                          a.settlement_amount_id - b.settlement_amount_id,
                      },
                      {
                        title: '업체명',
                        key: 'company_name',
                        dataIndex: 'company_name',
                        // width: 100,
                        align: 'center',
                      },
                      {
                        title: '주문금액',
                        key: 'sale_price',
                        dataIndex: 'sale_price',
                        width: 150,
                        align: 'center',
                        render: (val) => stringToMoneyFormat(val),
                        sorter: (a, b) => a.sale_price - b.sale_price,
                      },
                      {
                        title: '상품수',
                        key: 'sale_num',
                        dataIndex: 'sale_num',
                        width: 120,
                        align: 'center',
                        render: (val) => stringToMoneyFormat(val),
                        sorter: (a, b) => a.sale_num - b.sale_num,
                      },
                      {
                        title: '수수료',
                        key: 'commission_rate',
                        dataIndex: 'commission_rate',
                        width: 120,
                        align: 'center',
                        render: (val) => stringToMoneyFormat(val, '원'),
                        sorter: (a, b) => a.commission_rate - b.commission_rate,
                      },
                      {
                        title: '정산금액',
                        key: 'settlement_amount_price',
                        dataIndex: 'settlement_amount_price',
                        width: 150,
                        align: 'center',
                        render: (val) => stringToMoneyFormat(val),
                        sorter: (a, b) =>
                          a.settlement_amount_price - b.settlement_amount_price,
                      },
                      {
                        title: '정산상태',
                        key: 'settlement_amount_status',
                        dataIndex: 'settlement_amount_status',
                        width: 115,
                        align: 'center',
                        filters: Object.entries(SETTLEMENT_STATUS).map(
                          ([key, v]) => ({ text: v.title, value: key })
                        ), // [
                        render: (val) => SETTLEMENT_STATUS[val].title,
                        onFilter: (value, { settlement_amount_status }) =>
                          settlement_amount_status === value,
                      },
                      {
                        title: '생성일',
                        key: 'created_at',
                        dataIndex: 'created_at',
                        width: 185,
                        align: 'center',
                        render: (val) =>
                          moment(val * 1000).format('YYYY-MM-DD (HH:mm:ss)'),
                        sorter: (a, b) => a.created_at - b.created_at,
                      },
                      /* {
                        title: '출금상태',
                        key: 'settlement_amount_status',
                        dataIndex: 'settlement_amount_status',
                        width: 170,
                        align: 'center',
                        fixed: 'right',
                        render: (val, row) => (
                          <Select
                            style={{ width: '100%' }}
                            placeholder="출금상태"
                            disabled
                            // disabled={
                            //   permission !== 'ADMIN' || val === 'APPROVE'
                            // }
                            options={Object.keys(SETTLEMENT_STATUS).map(
                              (item) => ({
                                value: SETTLEMENT_STATUS[item].value,
                                label: SETTLEMENT_STATUS[item].title,
                              })
                            )}
                            value={val}
                            onChange={(e) => onChangeAmountStatus(row, e)}
                          />
                        ),
                      }, */
                    ]}
                  />
                </Content>
                {/* === Line 4 === */}
              </Content>
            </Col>
            {/* === 정산내역 - end === */}
          </Row>
        </Spin>
        {/* ==== Loading - end ==== */}
      </Content>

      {/* === 출금목록: start === */}
      <ModalLayout
        type="drawer"
        open={withdrawListModal}
        onCancel={setWithdrawListModal}
        centered
        closable
        title="출금내역"
        width={1500}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 0px',
          }}
        >
          {[
            {
              label: '출금완료',
              value: 0,
              value:
                withdrawList?.filter((i) => i.withdraw_status === 'APPROVE')
                  .length ?? 0,
              unit: '건',
            },
            {
              label: '출금대기',
              value: 0,
              value:
                withdrawList?.filter((i) => i.withdraw_status !== 'APPROVE')
                  .length ?? 0,
              unit: '건',
            },
            {
              label: '출금액',
              value: withdrawList
                ?.filter((i) => i.withdraw_status === 'APPROVE')
                ?.reduce((acc, cur) => (acc += cur?.withdraw_price ?? 0), 0),
            },
          ].map((_item, _index) => (
            <div
              style={{
                borderRight: _index < 2 ? '1px solid #EBEBEB' : 'none',
                width: '33.33',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              className={_item.onClick ? 'cursorOverOpacity' : ''}
              onClick={_item.onClick ?? null}
            >
              <h4
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: '#4B4B4B',
                  paddingRight: 30,
                }}
              >
                {_item.label}
              </h4>
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 400,
                  color: 'var(--black-color)',
                }}
              >
                {stringToMoneyFormat(_item.value, `${_item.unit ?? '원'}`)}
                {_item.subButton ? _item.subButton : null}
              </p>
            </div>
          ))}
        </div>
        <Divider />
        <>
          {/* <p style={{ marginBottom: 10 }}>내역({withdrawList?.length ?? 0})</p> */}
          <Table
            dataSource={withdrawList ?? []}
            scroll={{ x: 'max-content' }}
            columns={[
              {
                title: '출금처리일',
                dataIndex: 'created_at',
                width: 125,
                align: 'center',
                render: (v) => moment(v * 1000).format('YYYY-MM-DD (HH:mm:ss)'),
                sorter: (a, b) => a.created_at - b.created_at,
              },
              {
                title: '정산번호',
                dataIndex: 'settlement_amount_ids',
                width: 125,
                align: 'center',
                render: (settlement_amount_ids) =>
                  settlement_amount_ids?.map((i) => i).join(', '),
              },
              {
                title: '출금액',
                dataIndex: 'withdraw_price',
                width: 125,
                align: 'center',
                render: (v) => stringToMoneyFormat(v),
                sorter: (a, b) => a.withdraw_price - b.withdraw_price,
              },
              {
                title: '세금계산서',
                dataIndex: 'is_tax_bill',
                width: 150,
                align: 'center',
                render: (v) => (v === 'Y' ? '발행' : '미발행'),
                filters: [
                  { text: '발행', value: 'Y' },
                  { text: '미발행', value: 'N' },
                ],
                onFilter: (v, { is_tax_bill }) => v === is_tax_bill,
              },
              {
                title: '출금상태',
                dataIndex: 'withdraw_status',
                width: 125,
                align: 'center',
                render: (v) => (v === 'APPROVE' ? '출금완료' : '신청완료'),
                filters: [
                  { text: '출금완료', value: 'APPROVE' },
                  { text: '신청완료', value: 'APPLY' },
                ],
                onFilter: (v, { withdraw_status }) =>
                  withdraw_status.includes(v),
              },
              {
                title: '은행',
                dataIndex: 'bank_name',
                width: 125,
                align: 'center',
                filters: withdrawList?.reduce((acc, withdraw) => {
                  if (!acc.some((item) => item.value === withdraw.bank_name)) {
                    acc.push({
                      text: withdraw.bank_name,
                      value: withdraw.bank_name,
                    });
                  }
                  return acc;
                }, []),
                onFilter: (v, { bank_name }) => bank_name?.includes(v),
              },
              {
                title: '계좌번호',
                dataIndex: 'account_number',
                width: 270,
                align: 'center',
              },
              {
                title: '출금담당자',
                dataIndex: 'withdrawal_manager',
                width: 125,
                align: 'center',
                filters: withdrawList?.reduce((acc, withdraw) => {
                  const withdrawalManager = withdraw.withdrawal_manager.replace(
                    /\s+/g,
                    ''
                  ); // 모든 공백 제거
                  if (!acc.some((item) => item.value === withdrawalManager)) {
                    acc.push({
                      text: withdrawalManager,
                      value: withdrawalManager,
                    });
                  }
                  return acc;
                }, []),
                onFilter: (v, { withdrawal_manager }) =>
                  withdrawal_manager?.replace(/\s+/g, '')?.includes(v),
              },
              ...(permission === 'ADMIN'
                ? [
                    {
                      title: '#',
                      dataIndex: '#',
                      width: 125,
                      align: 'center',
                      fixed: 'right',
                      render: (_, record) => (
                        <Flex gap={3}>
                          <Button
                            disabled={record.withdraw_status !== 'APPLY'}
                            type="primary"
                            size="small"
                            onClick={() => {
                              setWithdrawApplicationModal(true);
                              onChangeWithdrawData(
                                'withdraw_id',
                                record.withdraw_id
                              );
                              setModalType('WITHDRAW_MANAGER');
                            }}
                          >
                            출금완료처리
                          </Button>
                          <Button
                            type="primary"
                            danger
                            size="small"
                            onClick={() => {
                              onDeleteWithdraw(record.withdraw_id);
                            }}
                          >
                            삭제
                          </Button>
                        </Flex>
                      ),
                    },
                  ]
                : []),
            ]}
          />
        </>
      </ModalLayout>
      {/* === 출금목록: end === */}

      {/* === 일괄출금처리: start === */}
      <ModalLayout
        // type="m"
        open={modalType === 'WITHDRAW_APPLICATION' && withdrawApplicationModal}
        onCancel={setWithdrawApplicationModal}
        centered
        closable
        title="출금정보 확인"
        width={720}
        footer={
          <div>
            <Button
              size="large"
              type="primary"
              // onClick={onChangeStatusAll}
              onClick={() => onWithdrawComplete(permission)}
            >
              {permission === 'ADMIN' ? '출금완료' : '출금신청'}
            </Button>
          </div>
        }
      >
        <>
          <Divider style={{ margin: '14px 0' }} />
          <Descriptions
            // title="User Info"
            // layout="vertical"
            bordered
            column={2}
            items={[
              {
                key: '1',
                label: '업체명',
                children: shopInformation?.shop_information_name ?? '-',
              },
              {
                key: '3',
                label: '대표자',
                children: shopInformation?.shop_information_address ?? '-',
              },
              {
                key: '2',
                label: '사업자번호',
                children:
                  shopInformation?.mall_information?.business_num ?? '-',
              },

              {
                key: '4',
                label: '세금계산서',
                children: (
                  <>
                    <Switch
                      checkedChildren="발행"
                      unCheckedChildren="미발행"
                      defaultChecked
                      value={withdrawData.is_tax_bill}
                      onChange={() =>
                        onChangeWithdrawData(
                          'is_tax_bill',
                          !withdrawData.is_tax_bill
                        )
                      }
                    />
                  </>
                ),
              },
              {
                key: '22',
                label: '출금담당자',
                span: 2,
                children: (
                  <Input
                    style={{ width: 180 }}
                    disabled={permission !== 'ADMIN'}
                    placeholder="출금담당자"
                    value={withdrawData.withdrawal_manager}
                    onChange={(e) =>
                      onChangeWithdrawData('withdrawal_manager', e.target.value)
                    }
                  />
                ),
              },
              {
                key: '6',
                label: '입금계좌정보',
                span: 2,
                children: (
                  <>
                    <Input
                      style={{ width: 120 }}
                      placeholder="은행"
                      value={withdrawData?.bank_name}
                      onChange={(e) =>
                        onChangeWithdrawData('bank_name', e.target.value)
                      }
                    />{' '}
                    <Input
                      style={{ width: 240 }}
                      placeholder="계좌번호"
                      value={withdrawData?.account_number}
                      onChange={(e) =>
                        onChangeWithdrawData('account_number', e.target.value)
                      }
                    />
                  </>
                ),
              },
              {
                key: '62',
                label: '비고',
                span: 2,
                children: (
                  <>
                    <Input
                      style={{ width: '100%' }}
                      placeholder="메모를 입력해주세요"
                      value={withdrawData?.etc}
                      onChange={(e) =>
                        onChangeWithdrawData('etc', e.target.value)
                      }
                    />
                  </>
                ),
              },
              {
                key: '5',
                label: '출금금액',
                children: (
                  <div>
                    {(() => {
                      console.log('selectedList: ', selectedList);
                    })()}
                    <Title size={4} align="left">
                      합계:{' '}
                      {stringToMoneyFormat(
                        selectedList &&
                          selectedList.reduce(
                            (acc, cur) =>
                              (acc += cur.settlement_amount_price ?? 0),
                            0
                          )
                      )}
                    </Title>
                    <Title size={5} align="left" color="#7a7a7a">
                      <small>판매금액</small>{' '}
                      {stringToMoneyFormat(
                        selectedList &&
                          selectedList.reduce(
                            (acc, cur) => (acc += cur.sale_price ?? 0),
                            0
                          )
                      )}
                      원 - <small>수수료</small>{' '}
                      {stringToMoneyFormat(
                        selectedList &&
                          selectedList.reduce(
                            (acc, cur) => (acc += cur.sale_price ?? 0),
                            0
                          ) -
                            selectedList.reduce(
                              (acc, cur) =>
                                (acc += cur.settlement_amount_price ?? 0),
                              0
                            )
                      )}
                      원 ={' '}
                      {stringToMoneyFormat(
                        selectedList &&
                          selectedList.reduce(
                            (acc, cur) =>
                              (acc += cur.settlement_amount_price ?? 0),
                            0
                          )
                      )}
                    </Title>

                    <ul
                      style={{
                        width: '100%',
                        background: '#fafafa',
                        padding: '3.5px 7px',
                        color: '#717171',
                        fontSize: '0.9em',
                        height: '100%',
                        maxHeight: 75,
                        overflowY: 'auto',
                        border: '1px solid #dadada',
                        marginTop: 7,
                      }}
                    >
                      <li>
                        <b>내역:</b>
                      </li>
                      {selectedList?.map((item) => (
                        <li>
                          - 판매금액(수수료):{' '}
                          {stringToMoneyFormat(item.sale_price)}원(
                          {stringToMoneyFormat(
                            item.sale_price - item.settlement_amount_price
                          )}
                          원) / 정산일:{' '}
                          {moment(item.created_at * 1000).format('YYYY-MM-DD')}
                        </li>
                      ))}
                      <li></li>
                    </ul>
                  </div>
                ),
              },
            ]}
          />
        </>
      </ModalLayout>
      {/* === 일괄출금처리: end === */}
      <ModalLayout
        // type="m"
        open={modalType === 'WITHDRAW_MANAGER' && withdrawApplicationModal}
        onCancel={setWithdrawApplicationModal}
        centered
        closable
        title="출금 정보 입력"
        width={720}
        footer={
          <div>
            <Button
              size="large"
              type="primary"
              onClick={() => onUpdateWithdraw()}
            >
              출금완료
            </Button>
          </div>
        }
      >
        <>
          <Divider style={{ margin: '14px 0' }} />
          <Descriptions
            bordered
            column={2}
            items={[
              {
                key: '22',
                label: '출금담당자',
                span: 2,
                children: (
                  <Input
                    style={{ width: 180 }}
                    disabled={permission !== 'ADMIN'}
                    placeholder="출금담당자"
                    value={withdrawData.withdrawal_manager}
                    onChange={(e) =>
                      onChangeWithdrawData('withdrawal_manager', e.target.value)
                    }
                  />
                ),
              },
            ]}
          />
        </>
      </ModalLayout>
    </>
  );
};

/* DF */
CalculateApplicationPresenter.defaultProps = {
  loading: false,
  setCurrentShop: () => {},
  onChangeAmountStatus: () => {},
};
export default CalculateApplicationPresenter;
